import { isNil, startCase } from 'lodash';
import {
  CannotAnswerReason,
  ReportInformation,
} from '../../types/reports';

export const getAnswer = (
  information: ReportInformation,
) => {
  if (!information) return '';
  const {
    cannotAnswer,
    cannotAnswerReason,
    questionType,
    value,
    units,
  } = information;

  if (cannotAnswer) {
    if (cannotAnswerReason) {
      return cannotAnswerReason === CannotAnswerReason.Other
        ? 'Refer to limitations'
        : startCase(cannotAnswerReason);
    }
    return 'Cannot Answer';
  }

  if (isNil(value)) return '';

  switch (questionType) {
    case 'string': {
      const parsedValue = JSON.parse(value);
      return Array.isArray(parsedValue) ? parsedValue.join(', ') : parsedValue;
    }
    case 'integer': {
      const integerValue = JSON.parse(value);
      return units ? `${integerValue} ${units.toLowerCase()}` : integerValue;
    }
    case 'boolean': {
      return JSON.parse(value) ? 'Yes' : 'No';
    }
    default:
      return '';
  }
};
